<template>
  <div v-if="currentUser" class="users-listing">
    <TolAlert v-if="tolAlert" v-bind="tolAlert" />

    <UsersFilters @change="onActiveInactiveChange" />
    <UsersAction />
    <tol-table
      :table-data="users"
      :columns="columns"
      :is-row-clickable="true"
      @row-click="onRowClick($event)"
    >
      <template v-slot:tableHeader>
        <!--<th>{{ $t('users.listing.labels.reference_number') }}</th> -->
        <th-sortable
          :direction="currentSortField === 'username' ? currentSortDirection : 'none'"
          field-name="username"
          @change="onSortOrderChange"
          >{{ $t('users.listing.labels.username') }}</th-sortable
        >

        <th-sortable
          :direction="currentSortField === 'name' ? currentSortDirection : 'none'"
          field-name="name"
          @change="onSortOrderChange"
          >{{ $t('users.listing.labels.name') }}</th-sortable
        >

        <th>{{ $t('users.listing.labels.roles') }}</th>
      </template>
      <!--
      <template v-slot:reference_number="{ value }">
        <router-link :to="value.reference_number">{{ value.reference_number }}</router-link>
      </template>
      -->
    </tol-table>

    <Pagination
      :records-per-page="UsersPerPage"
      :offset="currentPage"
      :record-count="recordCount"
      @change="onChangePaginationParams($event)"
    />
  </div>
</template>

<script>
import { UsersListingGetters, UsersListingActions } from './users-listing-keys';
import UsersFilters from './components/UsersFilters';
('@/app/features/tes-employees/features/tes-employees-listing/components/TesEmployeesFilters');
import TolAlert from '@/app/components/TolAlert';
import { AppActions } from '@/app/app.keys';
import TolTable from '@/app/components/TolTable';
import ThSortable from '@/app/components/ThSortable';
import Pagination from '@/app/components/Pagination';
import UsersAction from '../users-listing/components/UsersActions';

export default {
  name: 'UsersListing',
  components: {
    TolTable,
    TolAlert,
    ThSortable,
    Pagination,
    UsersFilters,
    UsersAction
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    tolAlert() {
      return false;
    },
    users() {
      return this.$store.getters[UsersListingGetters.UsersList];
    },
    UsersPerPage() {
      return this.$store.getters[UsersListingGetters.UsersPerPage];
    },
    currentPage() {
      return this.$store.getters[UsersListingGetters.UsersListingOffset];
    },
    recordCount() {
      return this.$store.getters[UsersListingGetters.UsersRecordCount];
    },
    currentSortField() {
      return this.$store.getters[UsersListingGetters.SortBy];
    },
    currentSortDirection() {
      return this.$store.getters[UsersListingGetters.SortDirection];
    },
    columns() {
      return ['username', 'name', 'roles'];
    },
    activeInactive() {
      return this.$store.getters[UsersListingGetters.UsersActiveInactive];
    }
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('users.listing.title'));
    this.$store.dispatch(UsersListingActions.RetrieveUsers);
  },
  methods: {
    onSortOrderChange(sortOrder) {
      this.$store.dispatch(UsersListingActions.UsersSortOrder, sortOrder);
    },
    onChangePaginationParams(event) {
      this.$store.dispatch(UsersListingActions.SetUsersPaginationParameters, event);
    },
    onActiveInactiveChange(activeInactive) {
      this.$store.dispatch(UsersListingActions.SetUsersActiveInactive, activeInactive);
    },
    onRowClick(evt) {
      this.$router.push(`/users/${evt.reference_number}`);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.users-listing {
  padding-left: 0;
}
</style>
